import Modal from "@/components/ui/Modal";
import AssignmentSubmissionModal from "@/pages/assignmentSubmission/AssignmentSubmissionModal";
import { useState } from "react";
import { Link } from "react-router-dom";

const CompleteAssignmentPopUp = () => {
  return (
    <div className="rounded-xl border bg-white shadow-sm w-[738px] p-8">
      <AssignmentSubmissionModal />
    </div>
  );
};

export default CompleteAssignmentPopUp;
